module.exports = "/assets/4b56b06699bdf01d0ae86738ab172c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QR.png
// module id = 1761
// module chunks = 0